import React from 'react'
import { EMPTY } from './Constants'

export default function OEITextInput(props) {
  return (
    <div className="oe-form-field">
      <label className="oe-form-field__title" htmlFor="042926878651436584">{props.label}</label>
      <textarea className="oe-form-field__control" id="042926878651436584" value={props.value} onChange={(e) => {
        props.setValue(e.target.value)
      }}></textarea>
      {props.errorMessage !== EMPTY ?
        <div className="oe-form-field__error">{props.errorMessage}</div>
        : EMPTY
      }
    </div>
  )
}
